import { cn } from '@/lib/utils'

interface JuneaIconProps {
  className?: string
}

export function JuneaIcon({ className }: JuneaIconProps): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-6', className)}
    >
      <path
        d="M19 0H5C4.73478 0 4.48043 0.105357 4.29289 0.292893C4.10536 0.48043 4 0.734784 4 1V18C4 18.2652 4.10536 18.5196 4.29289 18.7071C4.48043 18.8946 4.73478 19 5 19H19C19.2652 19 19.5196 18.8946 19.7071 18.7071C19.8946 18.5196 20 18.2652 20 18V1C20 0.734784 19.8946 0.48043 19.7071 0.292893C19.5196 0.105357 19.2652 0 19 0ZM18 17H6V2H18V17Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70711 19.7929C9.09763 20.1834 9.09763 20.8166 8.70711 21.2071L7.91422 22H16.0858L15.2929 21.2071C14.9024 20.8166 14.9024 20.1834 15.2929 19.7929C15.6834 19.4024 16.3166 19.4024 16.7071 19.7929L18.3536 21.4393C19.2985 22.3843 18.6293 24 17.2929 24H6.70711C5.37076 24 4.7015 22.3843 5.64645 21.4393L7.2929 19.7929C7.68342 19.4024 8.31659 19.4024 8.70711 19.7929Z"
        fill="var(--color-primary)"
      />
    </svg>
  )
}
